export default __webpack_public_path__ + "static/media/camera.8d6717ec.svg";